// The F-SHELL ↔ F-CASE seam (plan §8.4).
//
// F-SHELL owns the slot POSITION (between BrandBar and TabBar). F-CASE owns
// the wired strip: this file is now a thin wrapper delegating to
// `features/case/CaseStrip` — the real case picker (Tailwind + i18n + RTL,
// consuming `useCaseStore`). The single occupant means no slot-registry
// (that'd be over-engineering); F-CASE owns this file thereafter. Shell.tsx's
// layout is never touched by F-CASE.

import { CaseStrip } from '@/ui/features/case/CaseStrip'

export function CaseStripSlot(): JSX.Element {
  return <CaseStrip />
}
